let cdnStyles = [
  "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css",
];
let cdnScripts = [
  "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js"
];

function addStyles(urls) {
  urls.forEach(function (url) {
    let link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = url;
    document.head.appendChild(link);
  });
}

function addScripts(urls, callback) {
  let scriptsLoaded = 0;

  function checkScriptsLoaded() {
    scriptsLoaded++;
    if (scriptsLoaded === urls.length) {
      callback();
    }
  }

  urls.forEach(function (url) {
    let script = document.createElement("script");
    script.src = url;
    script.onload = checkScriptsLoaded;
    document.body.appendChild(script);
  });
}

window.addEventListener("DOMContentLoaded", function () {
  addStyles(cdnStyles);
  addScripts(cdnScripts, function () {
    // Swiper initialization code
const galleryTop = new Swiper("#zarf-dropslider", {
  slidesPerView: 1,
  speed: 600,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  watchSlidesProgress: true,
  watchSlidesVisibility: true,

  on: {
    slideChange: function () {
      var activeSlide = document.querySelector('.swiper-slide.swiper-slide-visible.swiper-slide-fully-visible');
      if (activeSlide) {
        var text1 = activeSlide.getAttribute('data-text1');
        var text2 = activeSlide.getAttribute('data-text2');
        var text3 = activeSlide.getAttribute('data-text3');

        // Update the first text
        document.querySelector('.zarf-productdrop .zarf-overlay-text h2').innerText = text1;

        // Update the second text
        document.querySelector('.zarf-productdrop .zarf-overlay-text p').innerText = text2;
        document.querySelector('.zarf-productdrop .zf-getbtn').href = text3;

        // Check if it's the last slide and hide the button
        // var isLastSlide = galleryTop.isEnd;
        // var discountButton = document.querySelector('.zf-discountbt');
        // if (discountButton) {
        //   discountButton.style.display = isLastSlide ? 'none' : 'flex';
        // }
      }
    },
  },
});


    const galleryThumbs = new Swiper("#zarf-dropthumb", {
      spaceBetween: 30,
      effect: "false",
      centeredSlides: true,
      slidesPerView: "auto",
      touchRatio: 0.2,
      slideToClickedSlide: true,
      speed: 600,
      breakpoints: {
        0: {
          slidesPerView: "auto",
          spaceBetween: 5,

        },
        1024: {
          slidesPerView: "auto",
          spaceBetween: 30,
        },
      },
    });

    galleryTop.controller.control = galleryThumbs;
    galleryThumbs.controller.control = galleryTop;

    const swiper = new Swiper("#zf-snitch", {
      slidesPerView: 5.5,
      centeredSlides: true,
      grabCursor: true,
      speed: 600,
      spaceBetween: 30,
      initialSlide: 2,
      centeredSlides: true,
      freeMode: true,
      // mousewheel: {
      //     releaseOnEdges: true,
      // },
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
        draggable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          freeMode:true,
          loop: false,
          slidesPerView: 1.4,
          initialSlide: false,
          spaceBetween: 20,
        },
        1024: {
          spaceBetween: 30,
          initialSlide: 1.5,
          freeMode: true,
          slidesPerView: 4.5,
        },
        1300: {
          spaceBetween: 30,
          initialSlide:2,
          freeMode: true,
          slidesPerView: 5.5,
        },
      },
    });

    var NewArrival = new Swiper("#zarf-NewArrivals", {
      slidesPerView:3,
      spaceBetween: 40,
      initialSlide: 1,
      centeredSlides: true,
      speed: 600,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          freeMode: false,
          loop: false,
          slidesPerView: 1,
          spaceBetween: 20,
             initialSlide: false,
        },
        1024: {
          spaceBetween: 30,
          freeMode: true,
        slidesPerView:3.1,
        },
      },
    });

    var review = new Swiper("#zarf-NewArrivals2", {
      slidesPerView: 3.3,
      spaceBetween: 20,
      centeredSlides: true,
         speed: 600,
      grabCursor: true,
      initialSlide: 1,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          freeMode: false,
          loop: false,
          slidesPerView: 1.2,
          initialSlide: false,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 3.3,
          spaceBetween: 30,
          freeMode: true,
        },
      },
    });

    var review = new Swiper("#zarf-gallerybox", {
      slidesPerView: 4,
      spaceBetween: 20,
          initialSlide:1.5,
        centeredSlides: true,
      speed: 600,
      grabCursor: true,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      breakpoints: {
        0: {
          freeMode: false,
          loop: false,
          slidesPerView: 1.2,
          initialSlide: false,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
          freeMode: true,
                initialSlide:1.5,
        },
      },
    });



    var collectionSwiper = new Swiper("#collection-productsl", {
  slidesPerView: 4,
  spaceBetween: 20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        1000: {
    slidesPerView: 4,
  spaceBetween: 15,
        },
    },
});

    /*------Related Products --------*/
    
var relatedSwiper = new Swiper('#related_product_slider', {
  slidesPerView: 4,
  spaceBetween: 15,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    320: { 
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 4,
    }
  },
});



var swiperContainers = document.querySelectorAll("#product-imgsli");

swiperContainers.forEach(function(swiperContainer) {
  var swiper = new Swiper(swiperContainer, {
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 600,
    autoplay: {
      delay:300,
      disableOnInteraction: false,
    },
    scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
      },
    
  });
    swiper.autoplay.stop();
if (window.innerWidth > 1000) {


  swiperContainer.addEventListener("mouseenter", function () {
    swiper.autoplay.start(); 
  });

  swiperContainer.addEventListener("mouseleave", function () {
    swiper.autoplay.stop(); 
  });
  }

});





    
  });
});

let audiobtn = document.querySelector("#play-audio");
let audio = document.querySelector("#zarf-audio");

audiobtn.addEventListener("click", () => {
  audio.play();

});

document.addEventListener("DOMContentLoaded", function() {
    const dots = document.querySelectorAll('.zarf-dot');
    const dotscontainer = document.querySelector('.zarf-pagination');
    const sections = document.querySelectorAll('.snipsection');
    const header = document.querySelector(".zarf-newHeader");
    const footer = document.querySelector(".zarf-footer"); // replace with your actual footer class
    const zarfmain = document.querySelector(".zarf-main");

    if( $('body').find('.timer-container').length > 0 ) {
      function myFunction(x) {
        zarfmain.addEventListener("scroll", function() {
          if (zarfmain.scrollTop < 20) {
            header.style.top = "45px";
          } else {
            header.style.top = "0";
          }
        });
        if (zarfmain.offsetTop < 20) {
          header.style.top = "45px";
        } else {
          header.style.top = "0";
        }
      }
    }

    // Create a MediaQueryList object
    var x = window.matchMedia("(max-width: 700px)")
    
    // Call listener function at run time
    myFunction(x);
    
    // Attach listener function on state changes
    x.addEventListener("change", function() {
      myFunction(x);
    });

    var observer = new IntersectionObserver(
        function (entries, observer) {
            var isBlackTextSectionInView = false;

            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add("showoverlay-text");
                  
                    // Check if the section has both classes
                    if (entry.target.classList.contains("color-black") && entry.target.classList.contains("showoverlay-text")) {
                        isBlackTextSectionInView = true;
                    }
                } else {
                    entry.target.classList.remove("showoverlay-text");
                }
            });

            // Add or remove the new class based on the presence of the classes in any section
            if (isBlackTextSectionInView) {
                header.classList.add("makedarkcolor");
            } else {
                header.classList.remove("makedarkcolor");
            }

            // Update active dot based on the currently visible section
            updateActiveDot();
        },
        { threshold: 0.5 }
    );

    sections.forEach(function (section) {
        observer.observe(section);
    });

    function updateActiveDot() {
        let currentSectionIndex = -1;

        // Determine which section is currently in view based on Intersection Observer
        sections.forEach((section, index) => {
            if (section.classList.contains('showoverlay-text')) {
                currentSectionIndex = index;
            }``
        });

        // Remove active class from all dots
        dots.forEach(dot => {
            dot.classList.remove('zarf-dot-active');
        });

        // Add active class to the dot corresponding to the current section
        if (currentSectionIndex !== -1) {
            const activeDot = dots[currentSectionIndex];
            if (activeDot) {
                activeDot.classList.add('zarf-dot-active');
            }
        }

        const isMakecolordarkHeader = header.classList.contains('makedarkcolor');
        dotscontainer.classList.toggle('zarf-darkdots', isMakecolordarkHeader);

        // Check if the footer is in view and hide the header accordingly
        const isFooterInView = isElementInView(footer);
        console.log('Footer in view:', isFooterInView); // Debugging statement
        header.style.display = isFooterInView ? 'none' : 'block';
    }

    // Function to check if an element is in view
    function isElementInView(element) {
        const rect = element.getBoundingClientRect();
        return rect.top >= 0 && rect.bottom <= window.innerHeight;
    }

    // Initial update of active dot
    updateActiveDot();

    // Event listener for scroll (optional, depending on your use case)
    window.addEventListener('scroll', updateActiveDot);
});




document.querySelector('#menu-openbutton').addEventListener('click', function () {
  document.querySelector('#zarf-menu').style.opacity = "1";
  document.querySelector('#zarf-menu').style.pointerEvents = "auto";
  document.querySelector('body:not(.Zarf-index)').style.overflow = "hidden";
});

document.querySelector('.close-mb-svg').addEventListener('click', function () {
  document.querySelector('#zarf-menu').style.opacity = "0";
  document.querySelector('#zarf-menu').style.pointerEvents = "none";
  document.querySelector('body:not(.Zarf-index)').style.overflow = "auto";
});

document.querySelectorAll('.zarf-mobilenav-body .menu-main-item').forEach(function(item) {
  item.addEventListener('click', function() {
    const nextElement = item.nextElementSibling;
    if (nextElement && nextElement.classList.contains('Zarf-Link-Menu')) {
      nextElement.classList.add('open-mobile-modal');
    }
  });
});

$('body').on('click', '#back-shopbutton', function(){
  $('.Zarf-Link-Menu').removeClass('open-mobile-modal');
});


let stitchcraft = document.querySelectorAll("#Stitch-craft");
let blacklabel = document.querySelectorAll("#blacklable");

stitchcraft.forEach(function (elem) {
  elem.addEventListener('click', function () {
        document.querySelector('.Zarf-Link-Menu').style.pointerEvents = "none";
        document.querySelector('.Zarf-Link-Menu').style.opacity = "0";
    document.querySelector(".zarf-snitchcraft").scrollIntoView({ block: 'center', behavior: 'smooth' });
    document.querySelector('#zarf-menu').style.opacity = "0";
    document.querySelector('#zarf-menu').style.pointerEvents = "none";
    document.querySelector('body:not(.Zarf-index)').style.overflow = "auto";

  });
});

blacklabel.forEach(function (elem) {
  elem.addEventListener('click', function () {
        document.querySelector('.Zarf-Link-Menu').style.pointerEvents = "none";
        document.querySelector('.Zarf-Link-Menu').style.opacity = "0";
    document.querySelector(".zarf-lable").scrollIntoView({ block: 'center', behavior: 'smooth' });
    document.querySelector('#zarf-menu').style.opacity = "0";
    document.querySelector('#zarf-menu').style.pointerEvents = "none";
    document.querySelector('body:not(.Zarf-index)').style.overflow = "auto";
      document.querySelector('.programmesbody').style.display = "none";
  });
});






document.addEventListener('DOMContentLoaded', function () {
  var contentToChange = document.getElementById('contentToChange');
  var imageToChange = document.getElementById('imageToChange');
  var bulkGiftingSection = document.querySelector('.Bulk-gifting-section');

      var data = [
        { text: 'Mumbai', image: 'https://cdn.shopify.com/s/files/1/0718/6248/5293/files/Group_238095.webp?v=1703503337', backgroundColor: 'var(--bulk-colorM)'},
        { text: 'Bangalore', image: 'https://cdn.shopify.com/s/files/1/0718/6248/5293/files/Group_238098.webp?v=1703503337', backgroundColor: 'var(--bulk-colorB)'},
        { text: 'Ahmedabad', image: 'https://cdn.shopify.com/s/files/1/0718/6248/5293/files/Group_238099.webp?v=1703503337', backgroundColor: 'var(--bulk-colorA)' },
        { text: 'Delhi', image: 'https://cdn.shopify.com/s/files/1/0718/6248/5293/files/Group_238097.webp?v=1703503337', backgroundColor: 'var(--bulk-colorD)' },
        { text: 'Chennai', image: 'https://cdn.shopify.com/s/files/1/0718/6248/5293/files/Group_238100.webp?v=1703503337', backgroundColor: 'var(--bulk-colorC)' },
        { text: 'Hyderabad', image: 'https://cdn.shopify.com/s/files/1/0718/6248/5293/files/Group_238096.webp?v=1703503337', backgroundColor: 'var(--bulk-colorH)' },
        { text: 'Jaipur', image: 'https://cdn.shopify.com/s/files/1/0718/6248/5293/files/Group_238104.webp?v=1703503337', backgroundColor: 'var(--bulk-colorJ)' },
        { text: 'Kolkatta', image: 'https://cdn.shopify.com/s/files/1/0718/6248/5293/files/Group_238102.webp?v=1703503338', backgroundColor: 'var(--bulk-colorK)' },
        { text: 'Lucknow', image: 'https://cdn.shopify.com/s/files/1/0718/6248/5293/files/Group_238104.webp?v=1703503337', backgroundColor: 'var(--bulk-colorL)' },
        { text: 'Pune', image: 'https://cdn.shopify.com/s/files/1/0718/6248/5293/files/Group_238103.webp?v=1703503337', backgroundColor: 'var(--bulk-colorP)' },
        // Add more text and image pairs as needed
      ];
  var currentIndex = 0;

  function changeTextAndImage() {
    var currentData = data[currentIndex];
    
    if (currentData) {
      contentToChange.innerText = currentData.text;
      imageToChange.src = currentData.image;
      bulkGiftingSection.style.backgroundColor = currentData.backgroundColor;
    
      currentIndex = (currentIndex + 1) % data.length;
    } else {
      console.error("Invalid data or index");
    }
  }

  changeTextAndImage();
  setInterval(changeTextAndImage, 800);
});

  function toggleAccordion(clickedHeader) {
    const accordionItem = clickedHeader.parentNode;
    const accordionBody = accordionItem.querySelector('.accordion-body');
    const icon = accordionItem.querySelector('.icon');


    const isAccordionOpen = accordionBody.classList.toggle('open');
    accordionBody.style.maxHeight = isAccordionOpen ? `${accordionBody.scrollHeight + 20}px` : '0'; /* Add the padding value */
    accordionBody.style.padding = isAccordionOpen ? '10px' : '0'; /* Toggle padding based on accordion state */

  
    icon.classList.toggle('rotate', isAccordionOpen);

   
    clickedHeader.classList.toggle('active', isAccordionOpen);

    if (isAccordionOpen) {
      const allAccordions = document.querySelectorAll('.accordion-item');
      allAccordions.forEach((item) => {
        if (item !== accordionItem) {
          const otherAccordionBody = item.querySelector('.accordion-body');
          const otherAccordionIcon = item.querySelector('.icon');
          const otherAccordionHeader = item.querySelector('.accordion-header');

          otherAccordionBody.classList.remove('open');
          otherAccordionBody.style.maxHeight = '0';
          otherAccordionBody.style.padding = '0';
          otherAccordionIcon.classList.remove('rotate');
          otherAccordionHeader.classList.remove('active');
        }
      });
    }
  }


var $sliderGutter = $('.slider-mobile-gutter');

$sliderGutter.on('scroll', function() {
    var isScrolledToBottom = this.scrollHeight - this.clientHeight <= this.scrollTop + 1;

    $(this).css('overflow-y', isScrolledToBottom ? 'hidden' : 'auto');
});

$sliderGutter.on('wheel', function(event) {
    if ($(this).css('overflow-y') === 'hidden' && event.originalEvent.deltaY < 0) {
        $(this).css('overflow-y', 'auto');
    }
});

$('body').on('click', '.grandChild_menuItem', function(event) {
  event.preventDefault();
  var nextElement = $(this).next();
  nextElement.toggleClass('open-mobile-modal');
});

$('body').on('click', '.backDrawerButton', function(event) {
  event.preventDefault();
  $(this).closest('.Zarf-Link-Menu').removeClass('open-mobile-modal');
});


